<template>
  <v-container fluid>
    <div>
      <a href="https://www.ovarro.com">{{ strings.ovarroWebsite }}</a>
    </div>
    <div>
      <a href="https://www.ovarro.com/en/europe/resource-hub">{{ strings.userGuides }}</a>
    </div>
    <div>
      <a
        href="https://www.ovarro.com/en/europe/contact-us/customer-support"
      >{{ strings.customerSupport }}</a>
    </div>
    <div>
      <a href="https://servicedesk.ovarro.com">{{ strings.customerSupportPortal }}</a>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AboutPage",
  computed: {
    ...mapGetters("page", ["strings"])
  }
};
</script>

<style scoped>
div {
  margin-top: 2rem;
}
a {
  color: #000;
  margin-top: 2rem;
}
</style>
